import s from "./PageShell.module.css";

export default function PageShell({ children, narrow }) {
  return (
    <div className={s.shell}>
      <div className={s.dots} />
      <div className={`${s.content} ${narrow ? s.narrow : ""}`}>
        {children}
      </div>
    </div>
  );
}
